import { trackLoginUserDetails } from "@DSG/Common/DSGTracking";
import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { chain, RedirectToChangeCustomer } from "@insite/client-framework/Store/Context/Handlers/SignIn";

if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}
addToEndOfChain(chain, addLoginTracking);

// get the type of props using this
type TrackingParameters = Parameters<typeof RedirectToChangeCustomer>[0];

function addLoginTracking(props: TrackingParameters) {
    const state = props.getState();
    trackLoginUserDetails(state);
}
